import 'babel-polyfill'
import Vue from 'vue'
import App from './App.vue'
import router from './router/router'
import store from './store/store'

// import * as Sentry from "@sentry/vue";
// import { BrowserTracing } from "@sentry/tracing";

import directive from './utils/directive'
import 'element-ui/lib/theme-chalk/index.css' // 引入ui样式
import ElementUI from 'element-ui'
import './assets/css/resetElement.css' // 重置ui样式
import './assets/css/common.css' // 重置ui样式
import VueScroller from 'vue-scroller'
import utils from './utils/utils' // 引用 Vue.use(utils); 将全局函数当做插件来进行注册

// Sentry.init({
//   Vue,
//   dsn: "https://03cdb99e644a41d7b641a137d7897dcb@sentry.zhipeicloud.com/51",
//   integrations: [
//     new BrowserTracing({
//       routingInstrumentation: Sentry.vueRouterInstrumentation(router),
//     }),
//   ],
//   environment: process.env.VUE_APP_BASE_ENVIRONMENTVARIABLE, // 环境变量
//   logErrors: true
// });

Vue.use(utils)
Vue.use(directive)
Vue.use(ElementUI)
Vue.use(VueScroller)
Vue.config.productionTip = false
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
